// src/components/Footer.jsx
import { useTranslation } from "react-i18next";
import LocalizedNavLink from "./LocalizedNavLink";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const itemCls =
    "px-2 py-1 rounded hover:bg-slate-50 hover:underline break-words";

  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-8">
        {/* Row A: legal links — stacked on mobile, inline on md+ with separators */}
        <ul
          className="flex flex-col items-center text-sm text-slate-600 gap-2
                     md:flex-row md:flex-wrap md:justify-center md:gap-3"
        >
          <li>
            <LocalizedNavLink to="/privacy" className={itemCls}>
              {t("footer.privacy")}
            </LocalizedNavLink>
          </li>

          <li className="hidden md:block w-px h-4 bg-slate-300" aria-hidden />

          <li>
            <LocalizedNavLink to="/cookies" className={itemCls}>
              {t("footer.cookies")}
            </LocalizedNavLink>
          </li>

          <li className="hidden md:block w-px h-4 bg-slate-300" aria-hidden />

          <li>
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener"
              className={itemCls}
            >
              {t("footer.odr")}
            </a>
          </li>

          <li className="hidden md:block w-px h-4 bg-slate-300" aria-hidden />

          <li>
            <a
              href="https://anpc.ro/"
              target="_blank"
              rel="noopener"
              className={itemCls}
              title="ANPC • Soluționare Alternativă a Litigiilor"
            >
              {t("footer.anpc")}
            </a>
          </li>

          <li className="hidden md:block w-px h-4 bg-slate-300" aria-hidden />

          <li>
            <a
              href="https://www.dataprotection.ro"
              target="_blank"
              rel="noopener"
              className={itemCls}
            >
              {t("footer.anspdcp")}
            </a>
          </li>
        </ul>

        {/* Row B: © left — Built with right (now under the links) */}
        <div className="mt-6 pt-3 border-t border-slate-200 flex flex-col items-center gap-1 md:flex-row md:items-center md:justify-between">
          <p className="text-sm text-slate-600">
            © {year} AndreiTech. {t("footer.rights")}
          </p>
          <p className="text-xs text-slate-500">{t("footer.built_with")}</p>
        </div>
      </div>
    </footer>
  );
}
